<template>
  <div class="grid pb-0">
    <div class="grid-title">
      <h4>{{ $t("PROMOTION") }}</h4>
      <v-btn color="primary" @click="addNew">
        <v-icon dark>
          mdi-plus
        </v-icon>
        {{ $t("ADD_NEW_PROMOTION") }}
      </v-btn>
    </div>
    <div class="grid-body border-top-unset">
      <v-row align="center" class="pb-3 pr-3 pl-3">
        <v-col sm="4">
          <v-text-field v-model="keyword" :label="$t('ENTER_NAME_OR_CODE')" v-on:change="getAll(true)"
            class="mt-0 pt-0"></v-text-field>
        </v-col>
        <v-col>
          <v-radio-group row v-model="radioGroup" class="mt-0" @change="$event => getAll(true)">
            <v-radio v-for="item in optionFilter" :key="item.key" :label="item.label" :value="item.key"></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>

      <v-progress-linear color="warning" indeterminate rounded height="3" v-if="isLoading"></v-progress-linear>
      <v-simple-table v-if="!isLoading" height="calc(100vh - 269px)" fixed-header>
        <thead>
          <tr>
            <th v-for="header in headers" :key="header.value" :class="header.class">
              {{ header.text }}
            </th>
          </tr>
        </thead>
        <template v-if="!isLoading">
          <draggable v-if="!isLoading" v-model="dataTable" tag="tbody" animation="150" handle=".sortHandle"
            @end="changeOrderListPromotion">

            <template v-if="dataTable.length > 0">
              <tr v-for="(item, i) in dataTable" :key="i">
                <td class="text-center vertical-middle">{{ i + 1 }}</td>
                <td class="text-left vertical-middle">
                  {{ item.promotionCode }}
                </td>
                <td class="font-weight-bold vertical-middle">
                  <a class="app-link text-decoration-none" href="javascript:;" @click="editItem(item)">
                    {{
                      item.promotionI18n.find(x => x.lang == defaultI18n).name
                    }}
                  </a>
                </td>
                <td class="text-left vertical-middle">
                  <span v-if="!item.stayingSession">{{ $t("ALWAYS") }}</span>
                  <span v-else>
                    {{ formatDate(item.startStayingDate) }} -
                    {{ formatDate(item.endStayingDate) }}
                  </span>
                </td>
                <td class="text-left vertical-middle">
                  <span v-if="!item.bookingSession">{{ $t("ALWAYS") }}</span>
                  <span v-else>
                    {{ formatDate(item.startBookingDate) }} -
                    {{ formatDate(item.endBookingDate) }}
                  </span>
                </td>
                <td class="text-left vertical-middle">
                  <template v-if="item.promotionBlackoutsBooking.length > 0">
                    <span v-for="(pro, ind) in item.promotionBlackoutsBooking" :key="ind">
                      {{ _moment(pro.startBookingDate).format("DD/MM/YYYY") }} -
                      {{ _moment(pro.endBookingDate).format("DD/MM/YYYY") }}
                      <br />
                    </span>
                  </template>
                </td>
                <td class="text-left vertical-middle">
                  <template v-if="item.promotionBlackoutsStaying.length > 0">
                    <span v-for="(pro, ind) in item.promotionBlackoutsStaying" :key="ind">
                      {{ _moment(pro.startBookingDate).format("DD/MM/YYYY") }} -
                      {{ _moment(pro.endBookingDate).format("DD/MM/YYYY") }}
                      <br />
                    </span>
                  </template>
                </td>
                <td class="text-center vertical-middle">
                  <div class="d-flex justify-center">
                    <v-switch v-model="item.status" @change="updateStatus(item)"
                      class="service-status mt-0 pt-0"></v-switch>
                  </div>
                </td>
                <td class="text-center vertical-middle text-nowrap">
                  <v-tooltip top transition="slide-y-reverse-transition">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn depressed @click="editItem(item)" x-small class="rounded-sm mr-1" v-bind="attrs" v-on="on"
                        color="primary" outlined>
                        <i class="icon-edit fs-16"></i>
                      </v-btn>
                    </template>
                    {{ $t("EDIT") }}
                  </v-tooltip>
                  <v-tooltip top transition="slide-y-reverse-transition">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn depressed @click="duplicateItem(item)" x-small v-bind="attrs" v-on="on"
                        class="rounded-sm mr-1" outlined>
                        <v-icon size="15">
                          content_copy
                        </v-icon>
                      </v-btn>
                    </template>
                    {{ $t("COPY") }}
                  </v-tooltip>
                  <v-tooltip top transition="slide-y-reverse-transition">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn depressed color="error" @click="$refs.deleteDialogComponent.open(item)" x-small
                        v-bind="attrs" v-on="on" class="rounded-sm mr-1" outlined>
                        <i class="icon-delete fs-16"></i>
                      </v-btn>
                    </template>
                    {{ $t("DELETE") }}
                  </v-tooltip>
                  <v-tooltip top transition="slide-y-reverse-transition">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn depressed x-small v-bind="attrs" v-on="on" class="rounded-sm sortHandle" outlined
                        style="cursor: move">
                        <v-icon size="15">
                          mdi-arrow-all
                        </v-icon>
                      </v-btn>
                    </template>
                    {{ $t("SORT") }}
                  </v-tooltip>
                </td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td colspan="8" class="text-center vertical-middle font-weight-bold font-italic" style="color:red">
                  {{ $t("NO_DATA") }}
                </td>
              </tr>
            </template>
          </draggable>
        </template>
      </v-simple-table>

      <b-row>
        <b-col md="4" class="d-flex align-center">
        </b-col>

        <b-col md="4" class="text-center">
          <a v-if="dataTable.length < paging.total" class="text-primary" @click="showMore()">{{
            $t('SHOW_MORE')
          }}
            <i class="icon-keyboard_double_arrow_down"> </i>
          </a>
        </b-col>
        <b-col md="4" class="text-right">
          <span v-if="paging" class="pr-3">{{ $tc('TO_PAGE', dataTable.length) }} | {{ $t("TOTAL") }}: {{ paging.total
          }}
            {{ $t("PROMOTION") }}</span>
        </b-col>
      </b-row>
      <delete-dialog @deleteItem="deleteItem" ref="deleteDialogComponent">
        <span slot="title">{{ $t("CONFIRM_DELETE_PROMOTION") }}?</span>
      </delete-dialog>
    </div>
  </div>
</template>

<script>
import Paging from "@/components/Utils/Paging.vue";
import DeleteDialog from "@/components/Utils/DeleteDialog.vue";
import draggable from "vuedraggable";
import ConfirmDialog from "@/components/Utils/ConfirmDialog.vue";
import { promotion } from "@/_services/SaleRoom/promotion.js";
import { _formatCurrency, _formatDate, _alert } from "@/_helpers/function.js";
import moment from "moment";
const toLower = text => {
  return text.toString().toLowerCase()
}
export default {
  components: {
    "delete-dialog": DeleteDialog,
    "confirm-dialog": ConfirmDialog,
    draggable,
    paging: Paging
  },
  data() {
    return {
      currency: null,
      isLoading: false,
      systemLang: this.$i18n.locale,
      isListingPage: true,
      dialog: false,
      sortDesc: true,
      headers: [
        {
          text: this.$t("STT"),
          class: "text-center"
        },
        {
          text: this.$t("PROMOTION_CODE"),
          value: "promotionCode",
        },
        {
          text: this.$t("PROMOTION_TITLE"),
          value: "name",
          class: "w-20"
        },
        {
          text: this.$t("TIME_STAY"),
          value: "stayDate"
        },
        {
          text: this.$t("TIME_SET"),
          value: "setDate"
        },
        {
          text: this.$t("DATE_OF_BOOKING_DOES_NOT_APPLY"),
          value: "notApplyDates"
        },
        {
          text: this.$t("DATE_OF_STAY_DOES_NOT_APPLY"),
          value: "endStayingDate"
        },
        {
          text: this.$t("STATUS"),
          value: "active",
          class: "text-center"
        },
        {
          text: this.$t("ACTION"),
          value: "action",
          class: "text-center"
        }
      ],
      data: [],
      dataTable: [],
      selected: [],
      editedIndex: -1,
      editedItem: null,
      keyword: "",
      status: "all",
      paging: {
        total: 0,
        limit: 15,
        offset: 0
      },
      orderBy: "active",
      asc: false,
      optionFilter: [
        {
          label: this.$t("ALL"),
          key: 'all'
        },
        {
          label: this.$t("SERVICE.ACTIVE"),
          key: 1
        },
        {
          label: this.$t("SERVICE.DEACTIVE"),
          key: 0
        }
      ],
      radioGroup: 'all',
      keyword: null,
      searched: [],
      listFilter: [],
    };
  },
  created() {
    this.isLoading = true
    this.currency = this.usedCurrency;
    this.getAll(true);
  },
  watch: {
    // listFilter: {
    //   handler(val) {
    //     this.isLoading = true
    //      setTimeout(() => {
    //          this.isLoading = false
    //      }, 100);
    //   }, deep: true
    // }
  },
  methods: {
    filterStatus(event) {
      this.isLoading = true
      let arr = []
      if (event == 'all') {
        arr = this.searched;
      } else {
        arr = this.searched.filter(item => item.status === event);
      }
      this.listFilter = JSON.parse(JSON.stringify(arr))
      setTimeout(() => {
        this.isLoading = false
      }, 100);
    },
    compare(a, b) {
      return (
        new Date(a.startBookingDate).getTime() -
        new Date(b.startBookingDate).getTime()
      );
    },

    async getAll(isSearching) {
      this.isLoading = true;
      if (isSearching) {
        this.paging.offset = 0;
        // this.data = [];
        this.dataTable = [];
      }
      let body = {};
      body.keyword = this.keyword;
      if (this.radioGroup === "all") {
        body.status = null;
      } else {
        body.status = this.radioGroup;
      }
      body.limit = this.paging.limit;
      body.offset = this.paging.offset;
      body.orderBy = this.orderBy;
      body.asc = this.asc;

      await promotion
        .get(body)
        .then(res => {
          // this.data = this.data.concat(res.data);
          this.dataTable = this.dataTable.concat(res.data);
          this.paging.total = res.total;
        })
        .finally(() => (this.isLoading = false));
    },
    showMore() {
      if (this.paging.total - this.dataTable.length > 0) {
        this.paging.offset += this.paging.limit;
        this.getAll();
      }
    },
    addNew() {
      this.$router.push({
        name: "promotionDetail",
        params: { id: "00000000-0000-0000-0000-000000000000" }
      });
    },
    editItem(item) {
      this.editedIndex = this.data.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.$router.push({
        name: "promotionDetail",
        params: { id: item.id }
      });
      localStorage.removeItem("RoomDetail");
    },
    cancelDelete(item) {
      item.status = !item.status;
    },
    deleteItem(item) {
      promotion.remove(item.id).then(res => {
        if (res.responseCode == 0) {
          this.getAll(true);
        }
        _alert(res, this.$t(res.data), false);
      });
    },
    changeOrderListPromotion() {
      const tmp = [];
      this.dataTable.forEach(element => {
        tmp.push(element.id);
      });

      promotion.sortIndex(tmp).then(res => {
        if (res.responseCode == 0) {
          _alert(res, this.$t(res.data), false);
        }
      });
    },
    duplicateItem(item) {
      promotion.duplicate([item.id]).then(res => {
        if (res.responseCode == 0) {
          this.getAll(true);
        }
        _alert(res, this.$t(res.data), false);
      });
    },
    redirect() {
      this.isListingPage = !this.isListingPage;
    },
    _formatCurrency: _formatCurrency,
    formatDate: _formatDate,
    _moment: moment,
    updateStatus(item) {
      let body = {
        id: item.id,
        status: item.status ? 1 : 0
      };
      promotion.updateStatus(body).then(res => {
        _alert(res, this.$t(res.data), true);
      });
    }
  }
};
</script>
